import toast from 'react-hot-toast';

const WP_ORIGEN = 'https://empresas-economiasocialysolidaria.com.mx';

// Llave de administrador: la página de administración de WordPress (privada)
// la entrega a este iframe con postMessage. Nunca va en la URL y solo vive en memoria.
let adminKey = '';

const recibirLlave = (e) => {
    if (e.origin === WP_ORIGEN && e.data && e.data.tipo === 'es-llave' && typeof e.data.k === 'string') {
        adminKey = e.data.k;
    }
};
if (typeof window !== 'undefined') {
    window.addEventListener('message', recibirLlave);
}

// Espera (máx. 3 s) a que la página de WordPress entregue la llave.
export const obtenerAdminKey = () => new Promise((resolve) => {
    if (adminKey || typeof window === 'undefined' || window.parent === window) {
        resolve(adminKey);
        return;
    }
    const alRecibir = (e) => {
        recibirLlave(e);
        if (adminKey) {
            clearTimeout(limite);
            window.removeEventListener('message', alRecibir);
            resolve(adminKey);
        }
    };
    const limite = setTimeout(() => {
        window.removeEventListener('message', alRecibir);
        resolve(adminKey);
    }, 3000);
    window.addEventListener('message', alRecibir);
    try {
        window.parent.postMessage({ tipo: 'es-solicitar-llave' }, WP_ORIGEN);
    } catch (e) { /* sin página padre de WordPress */ }
});

// Cabeceras para las llamadas de administración
export const cabecerasAdmin = async () => {
    const k = await obtenerAdminKey();
    return k ? { 'X-ES-Llave': k } : {};
};
// Versión sin espera (si la llave ya llegó), para vistas públicas
export const cabecerasAdminSiHay = () => (adminKey ? { 'X-ES-Llave': adminKey } : {});

// Tokens de edición validados en esta visita (solo en memoria)
const tokensEdicion = {};
export const setEditToken = (id, token) => { tokensEdicion[String(id)] = token; };
export const getEditToken = (id) => tokensEdicion[String(id)] || '';

// Muestra la respuesta de la API. Los errores de WordPress (401, 403, 429)
// no traen "status", y antes rompían toast[respuesta.status].
export const notificar = (respuesta, mensajeExito) => {
    if (respuesta && respuesta.status === 'success') {
        toast.success(mensajeExito || respuesta.message || 'Listo');
        return true;
    }
    toast.error((respuesta && respuesta.message) || 'Ocurrió un error');
    return false;
};
